import { defineFieldFormInterface } from "~/entities/field";
import InputAutocompleteInterface from "./InputAutocompleteInterface.vue";

export default defineFieldFormInterface({
  interface: "input-autocomplete-api",
  type: "string",
  component: InputAutocompleteInterface,
});
